import { useEffect, useState } from "react";
import { _PaymentFiles, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../../theme/Component/BasicTable";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import useModal, { MODAL_SM } from "../../../../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../../../../theme/Component/DropDown";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ExportXLSL } from "../../../../../../theme/Component/ExportXLSX";

interface Props {
    idPaymentFiles: number;
}
export const ReportPaymentFiles = ({ idPaymentFiles }: Props) => {

    const _paymentFiles = useDataBean(_PaymentFiles);
    const { bean, setBean, lista, setLista } = _paymentFiles;
    const paginador = usePaginator();
    const modalDownload = useModal("Consolidado", MODAL_SM);
    const [listaAll, setListaAll] = useState<any>([]);

    useEffect(() => {
        getPaymentFilesReport();
    }, [paginador.page]);

    const getPaymentFilesReport = () => {
        _paymentFiles.instance.getPaymentFilesReport(paginador.page, 15, { IDPaymentFiles: idPaymentFiles }).then((resp) => {
            setLista(resp.List);
            paginador.setPages(resp.NumberOfPages);
            paginador.setRecords(resp.NumberOfPages * (15));
            paginador.setRegiPerPage(15)
        }).catch((err) => {
            console.log(err);
        });
    }
    const getPaymentFilesReportAll = () => {
        _paymentFiles.instance.getPaymentFilesReport(paginador.page, paginador.records + 20, { IDPaymentFiles: idPaymentFiles }).then((resp) => {
            setListaAll(resp.List);

        }).catch((err) => {
            console.log(err);
        });
    }


    const head = [
        { title: 'ID', property: 'IDPaymentAccounts', visible: true, mask: MASK_NUMBER },
        { title: 'Identificación', property: 'EntityID', visible: true, maks: MASK_NUMBER },
        { title: 'Nombre', property: 'EntityName', visible: true },
        { title: 'Credito', property: 'CreditNumber', visible: true, mask: MASK_NUMBER },
        { title: 'Caja Nominadora', property: 'NameCajaNominadora', visible: true },
        { title: 'Descuento', property: 'PaymentValue', visible: true, mask: MASK_MONEY },
        { title: 'Cuenta Cobro', property: 'CXCValue', visible: true, mask: MASK_MONEY },
        { title: 'IAD Document', property: 'IADDocuments', visible: true },
        { title: 'Documento Pagos', property: 'PaymentDocuments', visible: true },
        { title: 'Pagos', property: 'TotalPaymentValue', visible: true, mask: MASK_MONEY },
    ]

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },


    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getPaymentFilesReportAll();
                            modalDownload.open();
                        }

                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <div>
            <BasicTable head={head} body={lista} rowSet={setBean} headButtons={buttons()}
                next={paginador.next}
                pageTop={paginador.page}
                back={paginador.back}
                records={paginador}
            />

            <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                <div className="row">
                    <div className="col-md-12">
                        {listaAll.length > 0 &&
                            <ExportXLSL customName={'files'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </div>
                </div>
            </Modal>

        </div>
    )
}   